import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import SaleReturnAdd from "../components/SaleReturnAdd";

const SaleReturnAddPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* InvoiceEditLayer */}
        <SaleReturnAdd />

      </MasterLayout>

    </>
  )
}
export default SaleReturnAddPage;
